export default {
  title: 'Nuestros Servicios',
  services: [
    {
      id: "tab1",
      img: '/images/services/viales-1.jpg',
      icon: '/images/icon1.png',
      title: 'Obras Viales, Pavimentos SERVIU y MOP',
      description: 'Construcción de calles, pavimentos de asfalto, hormigón, adocretos, adoquines. Ciclovías, aceras, soleras, dispositivos de rodados. Bahía de estacionamientos. Refugios peatonales. Demarcaciones, señalización, Rotondas, bandejones y más.',
      sel: true,
    },
    {
      id: "tab3",
      img: '/images/services/hormigon.jpg',
      icon: '/images/icon3.png',
      title: 'Obras Civiles',
      description: 'Pilas, muros de contención, lozas, shotcrete, obras de arte, dados de refuerzo, colectores, drenes, alcantarillado, aguas lluvias, aguas potables, estanques, canales, pavimentos, movimientos de tierra, canalizaciones, cámaras, poliductos y más.'
    },
    {
      id: "tab4",
      img: '/images/services/movimiento-de-tierra-1.jpg',
      icon: '/images/icon6.png',
      title: 'Habilitaciones',
      description: 'Habilitación de espacios, ejecución de Instalaciones Eléctricas, Corrientes Débiles, CCTV, Sistemas de Seguridad, Sistemas de Extinción y Detección contra incendios, PCI, Sanitario, Alcantarillado, AP, AS, ALL, etc. Ejecución de Terminaciones, Pavimentos, Muros, Cierres Perimetrales, Carpintería Metálica, Pintura, Cielos, Demarcaciones y Señales, etc.'
    },
    {
      id: "tab2",
      img: '/images/services/no-image.jpg',
      icon: '/images/icon2.png',
      title: 'Mitigaciones IMIV, EISTU, AVB y TEP',
      description: 'Ejecución de Medidas de Mitigación, Pavimentación, Señalización y Demarcación, Paisajismo y Riego, Iluminación y Alumbrado Público, Mobiliario Urbano, Plazas y Juegos, Ciclovías, Semaforización, Certificaciones. Balizas Zebra Safe, Vallas peatonales, Paraderos y más.'
    },

    // {
    //   id: "tab5",
    //   img: '/images/services/no-image.jpg',
    //   icon: '/images/icon5.png',
    //   title: 'Obras Civiles para Telecomunicaciones',
    //   description: 'Canalizaciones, poliductos, cámaras de servicio, atraviesos de calzada, paralelismos, obras de rotura y reposición de pavimentos, y más.'
    // },

    // {
    //   img: '/images/services/no-image.jpg',
    //   title: 'OOCC Energía Renovable',
    //   description: 'Licitando y proyectando nuevos desafíos.'
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/config.services.js